import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {authStore} from "../AuthStore";

export interface SlsUserItem {
    label: string,
    username: string
}

class SlsUserStore {
    get items(): SlsUserItem[] {
        return this._items;
    }

    set items(value: SlsUserItem[]) {
        this._items = value;
    }

    private _items: SlsUserItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async search(query: string): Promise<SlsUserItem[]> {
        const response = await catchApi(async () => api.sls.api.findUsers({query: query}))
        return (response?.data || []).map(item => ({
            label: `${item.firstname ? ` [${item.firstname}]` : ''} ${item.lastname ? ` [${item.lastname}]` : ''}`,
            username: `${item.username}`
        }))
    }

    async init() {
        const response = await catchApi(async () => api.sls.api.findUsers())
        if (response && response.data) {
            this.items = (response.data || []).map(item => ({
                label: `${item.firstname ? `${item.firstname}` : ''} ${item.lastname ? ` ${item.lastname}` : ''}`,
                username: `${item.username}`
            }))
        }
    }

    async loadUser(username: string | undefined): Promise<SlsUserItem | undefined> {
        if (!username) {
            return undefined
        }

        try {
            const response = await api.sls.api.getUserByUsername(username)
            return response?.data ? {
                label: `${response.data.firstname ? `${response.data.firstname}` : ''} ${response.data.lastname ? ` ${response.data.lastname}` : ''}`,
                username: `${response.data.username}`
            } : undefined;
        } catch (e) {
            return undefined
        }
    }

    async getUserFromStoreByUserName(username: string): Promise<SlsUserItem> {
        let userItem: SlsUserItem | undefined = this.items.filter(e => e.username === username)[0];

        if (!userItem) {
            userItem = await this.loadUser(username)
        }

        return userItem || {
            username: username,
            label: `Unknown (${username})`
        };
    }

    async getActiveUser(): Promise<SlsUserItem> {
        const username = authStore.user?.profile.preferred_username!!
        return this.getUserFromStoreByUserName(username);
    }
}

const slsUserStore = new SlsUserStore()

export {
    slsUserStore
}
